// app/src/components/SignUpPageMobilePartPanel2.tsx

import React, { FC } from 'react';
import { useTranslation } from "react-i18next";

interface SignUpPageMobilePartPanel2Props {
	isOpen: boolean;
	setIsOpen: (open: boolean) => void;
}

const SignUpPageMobilePartPanel2: FC<SignUpPageMobilePartPanel2Props> = ({
	isOpen,
	setIsOpen,
}) => {
	const { t } = useTranslation();

	const truncatedText = t('signupPanelPart:truncatedText');
	const fullText = t('signupPanelPart:fullText');

	return (
		<div
			style={{
				marginTop: 18,
				width: 277,
				height: isOpen ? 'auto' : 70,
				background: '#FFFFFF',
				borderRadius: 10,
				position: 'relative',
				padding: 12,
				boxShadow: '0px 1px 6px #00000029',
				transition: 'height 0.3s ease',
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					cursor: 'pointer',
					position: 'relative',
				}}
				onClick={() => setIsOpen(!isOpen)}
			>
				{/* Le texte tronqué ou complet */}
				<div style={{ width: '90%' }}>
					{isOpen && (
						<div
							style={{
								marginTop: 3,
								fontSize: 11,
								color: '#323E48',
								lineHeight: '1.4',
								whiteSpace: 'pre-wrap',
							}}
						>
							{fullText}
						</div>
					)}
					{!isOpen && (
						<div
							style={{
								marginTop: 3,
								fontSize: 11,
								color: '#323E48',
								lineHeight: '1.4',
								whiteSpace: 'pre-wrap',
								textAlign: 'center',
							}}
						>
							{truncatedText}
						</div>
					)}
				</div>

				{/* Chevron à droite */}
				<div
					style={{
						position: 'absolute',
						right: 0,
						top: 0,
					}}
				>
					{isOpen ? (
						<img
							src="/images/chevron-down.svg"
							alt="chevron-down"
							style={{ width: 16, height: 16 }}
						/>
					) : (
						<img
							src="/images/chevron-right.svg"
							alt="chevron-right"
							style={{ width: 16, height: 16 }}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default SignUpPageMobilePartPanel2;
